import React from 'react'
import { ListItemText }from '@mui/material'

export default function Timer({minSecs, isRunning, setTime, inverse=false}) {


    const { minutes = 0, seconds = 0 } = minSecs;
   
    const [mins, secs] = [minutes, seconds]


    const tick = () => {
        
        if (!inverse) {
            if ( mins === 0 && secs === 0) 
                reset()
                // change this too end the game
            else if (secs === 0) {
                setTime({minutes: mins - 1, seconds: 59});
            } else {
                setTime({minutes: mins, seconds: secs - 1});
            }
        } else {
            if (secs === 59) {
                setTime({minutes: mins + 1, seconds: 0});
            } else {
                setTime({minutes: mins, seconds: secs + 1});
            }

        }
    };


    const reset = () => setTime({ minutes: parseInt(minutes), seconds: parseInt(seconds)});

    
    React.useEffect(() => {
        if (isRunning) {
            const timerId = setInterval(() => tick(), 1000);

            return () => clearInterval(timerId);
        }
    });

    
    return (
        <ListItemText
            primaryTypographyProps={{
                fontSize: { xs: '1.2rem', sm: '1.6rem', md: '1.75rem', lg: '1.9rem' }
            }}
            secondaryTypographyProps={{
                fontSize: { xs: '1rem', sm: '1.3rem', md: '1.5rem', lg: '1.7rem' }
            }}
            primary={`${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`}
        />
    )
}